module.exports = __webpack_public_path__ + "fonts/fa-regular-400.9029dd15.eot";